import { render, staticRenderFns } from "./TemplateMaker.vue?vue&type=template&id=622888c6"
import script from "./TemplateMaker.vue?vue&type=script&lang=js"
export * from "./TemplateMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622888c6')) {
      api.createRecord('622888c6', component.options)
    } else {
      api.reload('622888c6', component.options)
    }
    module.hot.accept("./TemplateMaker.vue?vue&type=template&id=622888c6", function () {
      api.rerender('622888c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/TemplateMaker.vue"
export default component.exports